import React from 'react';
import './MedicalAssistantDashboard.css';
import { useNavigate } from 'react-router-dom';
import { templateData } from '../data/templateData';
const MedicalAssistantDashboard = () => {
  const navigate = useNavigate();  

  // Function to get initials from name
  const getInitials = (name) => {
    if (!name) return "";
    return name.split(' ').map(word => word[0]).join('').substring(0, 2);
  };

  return (
    <div className="dashboard-container">
      {templateData.map((assistant, index) => (
        <div  key={index} className="assistant-card" onClick={() => { navigate('/tasks/new/'+assistant.service)}}>
          {/* Photo Section with New/AI badges */}
          <div className="card-image-container" >
            <img 
              src={assistant.photo} 
              alt={assistant.name} 
              className="card-image"
            />
            {assistant.ai && (
              <div className="badge-container-ai">
                <span className="badge-ai">AI</span>
              </div>
            )}
            {assistant.isNew && (
              <div className="badge-container-new">
                <span className="badge-new">New</span>
              </div>
            )}
          </div>
          
          {/* Details Section */}
          <div className="card-details">
            <h3 className="assistant-name">{assistant.name}</h3>
            <p className="assistant-service">{ assistant.service } </p>
            
            {/* Tags */}
            <div className="tags-container">
              {assistant.tags.map((tag, idx) => (
                <span key={idx} className="tag">{tag}</span>
              ))}
            </div>
          </div>
          
          {/* Creator Section */}
          <div className="card-footer">
            {assistant.creator.type === "Corporate" ? (
              <div className="creator-info">
                <div className="creator-avatar corporate-avatar">
                  <span className="avatar-text">H</span>
                </div>
                <div className="creator-details">
                  <p className="creator-label">Corporate Creator:</p>
                  <p className="creator-name">{assistant.creator.name}</p>
                </div>
              </div>
            ) : (
              <>
                <div className="creator-info">
                  <div className="creator-avatar individual-avatar">
                    <span className="avatar-text">{getInitials(assistant.name)}</span>
                  </div>
                  <div className="specialty-info">
                  <p>Specialty: {assistant.specialty}</p>
                  <p>Subspecialty: {assistant.subspecialty}</p>
                </div>
                </div>
                
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default MedicalAssistantDashboard;
